
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_1c7xb_193",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_1c7xb_198",
  "size-x-small": "awsui_size-x-small_h11ix_1c7xb_235",
  "size-x-small-mapped-height": "awsui_size-x-small-mapped-height_h11ix_1c7xb_239",
  "size-small": "awsui_size-small_h11ix_1c7xb_257",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_1c7xb_261",
  "size-normal": "awsui_size-normal_h11ix_1c7xb_279",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_1c7xb_283",
  "size-medium": "awsui_size-medium_h11ix_1c7xb_301",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_1c7xb_305",
  "size-big": "awsui_size-big_h11ix_1c7xb_323",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_1c7xb_327",
  "size-large": "awsui_size-large_h11ix_1c7xb_345",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_1c7xb_349",
  "variant-normal": "awsui_variant-normal_h11ix_1c7xb_367",
  "variant-disabled": "awsui_variant-disabled_h11ix_1c7xb_370",
  "variant-inverted": "awsui_variant-inverted_h11ix_1c7xb_373",
  "variant-subtle": "awsui_variant-subtle_h11ix_1c7xb_376",
  "variant-warning": "awsui_variant-warning_h11ix_1c7xb_379",
  "variant-error": "awsui_variant-error_h11ix_1c7xb_382",
  "variant-success": "awsui_variant-success_h11ix_1c7xb_385",
  "variant-link": "awsui_variant-link_h11ix_1c7xb_388",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_1c7xb_391",
  "name-angle-left": "awsui_name-angle-left_h11ix_1c7xb_391",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_1c7xb_393",
  "name-angle-right": "awsui_name-angle-right_h11ix_1c7xb_393",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_1c7xb_395",
  "name-arrow-right": "awsui_name-arrow-right_h11ix_1c7xb_396",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_1c7xb_397",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_1c7xb_398",
  "name-audio-full": "awsui_name-audio-full_h11ix_1c7xb_399",
  "name-audio-half": "awsui_name-audio-half_h11ix_1c7xb_400",
  "name-audio-off": "awsui_name-audio-off_h11ix_1c7xb_401",
  "name-external": "awsui_name-external_h11ix_1c7xb_402",
  "name-redo": "awsui_name-redo_h11ix_1c7xb_403",
  "name-resize-area": "awsui_name-resize-area_h11ix_1c7xb_404",
  "name-send": "awsui_name-send_h11ix_1c7xb_405",
  "name-shrink": "awsui_name-shrink_h11ix_1c7xb_406",
  "name-undo": "awsui_name-undo_h11ix_1c7xb_407",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_1c7xb_408",
  "badge": "awsui_badge_h11ix_1c7xb_432"
};
  